import MasterTab from 'src/components/Layouts/MasterTab.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import ActivityLog from './ActivityLog.vue';

const ActivityLogRoutes = {
  path: 'grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'activitylog',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.log',
          component: ActivityLog,
          meta: {
            prefix_permission: 'grow_log',
          },
        },
      ],
    },
  ],
};

export default ActivityLogRoutes;
